import { render, staticRenderFns } from "./HandleClient.vue?vue&type=template&id=cea6cf2a&scoped=true"
import script from "./HandleClient.vue?vue&type=script&lang=js"
export * from "./HandleClient.vue?vue&type=script&lang=js"
import style0 from "./HandleClient.vue?vue&type=style&index=0&id=cea6cf2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea6cf2a",
  null
  
)

export default component.exports